import { render, staticRenderFns } from "./AllBills.vue?vue&type=template&id=3b765546&scoped=true&"
import script from "./AllBills.vue?vue&type=script&lang=js&"
export * from "./AllBills.vue?vue&type=script&lang=js&"
import style0 from "./AllBills.vue?vue&type=style&index=0&id=3b765546&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b765546",
  null
  
)

export default component.exports